var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.tournamentHistory}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }